interface DQEStateObject {
  isEmailValid: boolean;
  isMobilePhoneValid: boolean;
}

export const initialState: DQEStateObject = {
  isEmailValid: false,
  isMobilePhoneValid: false
};

export const DQEReducer = (state: DQEStateObject, action: any) => {
  switch (action.type) {
    case "UPDATE_EMAIL_VALID":
      return { ...state, isEmailValid: action.payload };
    case "UPDATE_PHONE_VALID":
      return { ...state, isMobilePhoneValid: action.payload };
    case "RESET":
      return initialState;
    default:
      return initialState;
  }
};

export type SetDQEState = React.Dispatch<React.SetStateAction<DQEStateObject>>;

export type DQEState = [DQEStateObject, SetDQEState];
